module.exports = __webpack_public_path__ + "img/feven_move.b1a8e375.svg";